import * as PhoneInput from './PhoneInput.css';

export default {
	PhoneInput
};
